import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

import { BruningTrashIcon, SupportIcon } from "./icons";

export default function ServerError() {
  const handleSupport = () => {
    if (!window.Intercom) {
      return;
    }

    window.Intercom("show");
  };

  return (
    <>
      <title>Everything is fine</title>
      <Dialog open>
        <DialogContent
          className="gap-0 bg-transparent"
          overlayClassName="bg-[url(/images/body.png)] bg-midnight-express bg-size-[300%] bg-top md:bg-size-[100%]"
        >
          <DialogHeader className="items-center px-6">
            <BruningTrashIcon className="aspect-[298/240] h-auto w-[79%] max-w-74.5" />
            <DialogTitle className="mt-5 text-center font-semibold text-20/[1.4em] text-white">
              Everything is fine
            </DialogTitle>
          </DialogHeader>
          <div className="py-3.5">
            <p className="text-center text-15/[1.5em] text-white">
              Sometimes things just catch fire. Fire is natural, right? 🧐
              <br />
              <br />
              Please let us know if a reload doesn&apos;t fix it.
            </p>
          </div>
          <DialogFooter className="px-6 py-6.5">
            <div className="mx-auto w-full max-w-84 flex-col items-stretch">
              <Button
                className="flex h-[49px] w-full items-center rounded-[5px] bg-white/10 text-14 text-white"
                onClick={handleSupport}
              >
                <SupportIcon />
                Have a question?
                <strong className="font-semibold underline">
                  Contact our team
                </strong>
              </Button>
            </div>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
